<div class="wrap">
	<div>
		<a class="logo" routerLink="/">
			<tk-icon icon="tk_logo" />
		</a>
		<ul class="list">
			<li>
				<a class="list__item" routerLink="/articles" routerLinkActive="active">
					<tk-icon icon="doc_used" />
				</a>
			</li>
			<li>
				<a class="list__item" routerLink="/mail" routerLinkActive="active">
					<tk-icon icon="mail" />
				</a>
			</li>
			<li>
				<a class="list__item" routerLink="/authors" routerLinkActive="active">
					<tk-icon icon="users" />
				</a>
			</li>
			<li>
				<a class="list__item" routerLink="/tags" routerLinkActive="active">
					<tk-icon icon="tag" />
				</a>
			</li>
		</ul>
	</div>
	<button (click)="logout()" class="exit">
		<tk-icon icon="exit" />
	</button>
</div>
